<template>
  <div class="splash-screen" id="splash-screen" v-if="false">
    <svg width="214" height="120" viewBox="0 0 214 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M208.682 29.7116C205.645 34.1364 202.209 38.27 198.419 42.0668C194.195 46.3831 189.201 50.1399 185.313 50.1399C184.252 50.1399 183.07 49.763 183.07 46.3545C183.327 42.3637 184.252 38.4413 185.804 34.7531C185.804 34.7531 183.647 34.0166 179.337 32.2524C177.094 29.7003 173.886 28.2101 170.496 28.1416C165.644 28.2386 161.129 30.6194 158.298 34.5703C156.192 37.2423 154.639 39.3833 153.372 40.982C149.371 46.1261 143.931 50.1684 139.69 50.1684C138.623 50.2198 137.59 49.7916 136.87 49.0037C136.151 48.2158 135.814 47.1482 135.957 46.0862C136.294 43.6597 136.91 41.2846 137.806 39.0065C139.074 34.6217 137.515 31.6357 132.435 30.8136C126.448 40.4967 122.172 50.1627 114.216 50.1627C110.882 50.1627 108.331 47.8162 108.331 43.3057C108.331 34.1536 116.881 21.6271 122.903 12.218C127.897 4.29912 123.93 1.13046 120.557 0C119.564 1.37025 109.798 16.1119 104.015 24.1279C99.2094 30.8307 88.1932 34.0851 82.1028 34.3077C80.0251 30.5624 76.1152 28.2101 71.8399 28.1358C63.6605 28.1358 59.6421 34.5818 58.4434 36.2089C57.2448 37.8361 54.7162 41.0562 54.4422 41.3531C47.4271 49.7859 43.6999 50.0599 40.7603 50.0599C37.6723 49.8544 34.6471 49.0893 31.8331 47.799C39.8756 33.6626 48.3233 20.7879 53.352 12.9774C58.1409 5.5381 55.0643 1.27316 50.6464 0.0399351C49.2251 2.07819 35.7316 21.2389 22.7632 44.3734L14.384 41.2732C14.384 41.2732 9.88613 49.2606 15.7881 52.0525C16.0621 52.2066 16.5073 52.4122 17.1066 52.7034L18.0656 53.1659C8.23084 71.8984 0 91.6757 0 105.384C0 115.478 5.25129 120 10.4512 120C13.8703 120 20.714 117.842 29.0647 103.46C34.727 93.6911 37.9748 82.8947 37.9748 74.5647C37.8778 68.9352 36.8275 63.3571 34.8811 58.0759C36.388 58.4299 37.9235 58.6297 39.4646 58.6754C45.6748 58.9494 51.046 57.819 57.1192 50.4653C58.7174 55.2783 63.1582 58.5612 68.2211 58.6754C77.8675 58.6754 83.8894 48.958 83.8894 43.4713C90.0825 42.6206 95.9902 40.3026 101.116 36.7171C100.437 38.5898 100.071 40.5538 100.02 42.5463C100.02 53.1544 106.333 58.6583 114.164 58.6583C119.992 58.5099 125.392 55.5467 128.651 50.7051C128.651 54.8844 131.864 58.6583 139.153 58.6583H140.558C141.123 58.6583 141.534 58.5555 141.962 58.5041L143.246 58.2301C144.051 58.0303 144.85 57.7733 145.626 57.4764C148.446 56.3288 151.072 54.7587 153.429 52.8347C154.285 52.1667 155.141 51.4473 155.912 50.7279C157.556 55.3754 161.871 58.5441 166.791 58.7154C170.741 58.4813 174.4 56.5401 176.814 53.3999C178.173 56.6714 181.404 58.7724 184.942 58.6811C196.404 58.6811 209.253 41.9183 211.439 38.9209C213.63 35.9235 214.738 31.276 208.687 29.7687M21.2734 98.3728C16.7071 106.412 12.723 111.19 11.3359 111.19C10.3599 111.19 9.52081 108.604 9.52081 105.378C9.52081 93.6569 16.7756 76.1233 25.7028 59.1036C27.672 62.6149 28.6081 67.6734 28.6081 74.6503C28.6081 81.0962 25.8854 90.3511 21.2677 98.4528M74.38 43.9052C73.0101 47.9303 69.9677 50.9848 67.5362 50.7622C65.1046 50.5395 64.3055 47.0111 65.6697 42.9803C67.0396 38.9551 70.0648 35.8835 72.5135 36.1233C74.9622 36.3631 75.7442 39.8743 74.3971 43.9052M166.272 50.7622C163.823 50.5395 163.041 47.0111 164.405 42.9803C165.775 38.9551 168.8 35.8835 171.249 36.1233C173.698 36.3631 174.48 39.8743 173.116 43.9052C171.763 47.9303 168.721 50.9848 166.272 50.7622ZM145.369 8.87807C148.223 8.87807 149.439 12.3037 148.058 16.6771C146.671 21.0448 143.269 24.4762 140.409 24.4762C137.55 24.4762 136.339 21.0505 137.721 16.6771C139.074 12.3779 142.51 8.87807 145.369 8.87807Z" fill="#F04E23"/>
    </svg>

    <button class="splash-screen-sign-in-btn"  @click="signIn">
      <span class="title-btn">Log in</span>
    </button>
  </div>
</template>

<script>
import { inject, onBeforeMount, onMounted } from "vue";
import ActionButton from "../common/ActionButton.vue";
import PlusIcon from "../../assets/vue-icons/plus-icon.vue";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "SplashScreen",
  components: { PlusIcon, ActionButton },
  setup() {
    const $auth0 = inject("$auth0");
    const route = useRoute();

    onMounted(() => {
      $auth0.signIn(route.query.to);
    });

    function signIn() {
      $auth0.signIn();
    }

    return { signIn }
  }
};
</script>

<style lang="scss" scoped>
.splash-screen-sign-in-btn {
  position: absolute;
  bottom: 30%;
  width: 138px;
  display: flex;
  height: 36px;
  padding: 8px 16px;
  background: #334155;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  border: 1px solid #334155;

  &:hover {
    box-shadow: 0 0 4px 4px #e6e6e6;
  }

  .title-btn {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
}

</style>